import { EmotionIconProps } from '@emotion-icons/emotion-icon'

export const RadiusRingsIcon = (props: EmotionIconProps) => {
  const { fill, color, size } = props
  return (
    <svg width={size} height={size} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 16.5C13.1421 16.5 16.5 13.1421 16.5 9C16.5 4.85786 13.1421 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5ZM9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z"
        fill={fill || color || 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.00005 13.5C11.4853 13.5 13.5001 11.4853 13.5001 9C13.5001 6.51472 11.4853 4.5 9.00005 4.5C6.51477 4.5 4.50005 6.51472 4.50005 9C4.50005 11.4853 6.51477 13.5 9.00005 13.5ZM9.00005 15C12.3138 15 15.0001 12.3137 15.0001 9C15.0001 5.68629 12.3138 3 9.00005 3C5.68634 3 3.00005 5.68629 3.00005 9C3.00005 12.3137 5.68634 15 9.00005 15Z"
        fill={fill || color || 'currentColor'}
      />
      <path
        d="M12 9C12 10.6569 10.6569 12 9.00004 12C7.34318 12 6.00004 10.6569 6.00004 9C6.00004 7.34315 7.34318 6 9.00004 6C10.6569 6 12 7.34315 12 9Z"
        fill={fill || color || 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.00004 12C10.6569 12 12 10.6569 12 9C12 7.34315 10.6569 6 9.00004 6C7.34318 6 6.00004 7.34315 6.00004 9C6.00004 10.6569 7.34318 12 9.00004 12Z"
        fill={fill || color || 'currentColor'}
      />
    </svg>
  )
}
